import { type UseSuspenseQueryOptions } from "@tanstack/react-query";

import { backendApi } from "src/backendApi/backendApi";
import type { AsssembleSurveyConfigResponse } from "@typings/mightierApiTypes";

export const makeSurveyConfigQueryOpts = (
  surveyId: string,
  meta: string,
): UseSuspenseQueryOptions<AsssembleSurveyConfigResponse> => {
  return {
    queryKey: ["survey-config", surveyId, meta],
    queryFn: async (): Promise<AsssembleSurveyConfigResponse> => {
      const resp = await backendApi.assembleSurvey(surveyId, meta);
      return resp.data;
    },
    // this data is pretty much static - do not refetch no matter how long between mounts!
    // the only exception is upon page refresh of course
    staleTime: Infinity,
    gcTime: Infinity,
  };
};
